export const baseUrl =
  process.env.REACT_APP_CI_DEPLOY || process.env.NODE_ENV === "development"
    ? "https://crm-staging.classplus.co/staging"
    : "https://crm.classplus.co";
